/**
 * Created by nmayer on 09.06.16.
 */
define('modules/settings/systemMessage/SystemMessageListController',[
        'modules/module',
        'settings',
        'modules/basemodule/controllers/EntityListController'
    ],
    function (module) {
        'use strict';
        module.controller('SystemMessageListController', ['$scope', '$controller', 'BASE_TEMPLATES_PATH',
            function ($scope, $controller, BASE_TEMPLATES_PATH) {

                angular.extend(this, $controller('EntityListController', {
                    $scope: $scope
                }));

                $scope.tableOptions.fields = [
                    {
                        id: 'NAME',
                        heading:    'Name',
                        attribute:  'name'
                    },
                    {
                        id: 'STATE',
                        heading:    'State',
                        attribute:  'state'
                    }
                ];
                $scope.formState = 'root.systemMessage';

                $scope.init('SystemMessage');
            }
        ]);
    }
);


